import api from 'api';

export class ServicesStore {
  protected services = { api };
}
